import React from 'react';
import { Box } from '@mui/material';

const Factor6Loading = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Box
        sx={{
          display:'flex',
          height: 'auto',
          width: 'auto',
          animation: 'breathing 2s ease-in-out infinite',
        }}
      >
        <img src="/assets/Factor6_Blue.png" alt="Factor6 Loading" />

        <style>
          {`
      @keyframes breathing {
        0% {
          transform: scale(1);
          }
          50% {
            transform: scale(1.1);
            }
            100% {
              transform: scale(1);
              }
              }
              `}
        </style>
      </Box>
    </div>
  );
};

export default Factor6Loading;
